import React from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface NumberInputLabelProps {
  labelId: string;
  fieldName: string;
  required: boolean;
}

const NumberInputLabel: React.FC<NumberInputLabelProps> = ({
  labelId,
  fieldName,
  required,
}) => {
  const { t } = useTranslation();

  const hasTitle = t(`${fieldName}.title`) !== `${fieldName}.title`;
  const hasExplanation =
    t(`${fieldName}.explanation`) !== `${fieldName}.explanation`;
  const hasLabel = t(`${fieldName}.label`) !== `${fieldName}.label`;

  return (
    <Form.Label id={labelId} htmlFor={fieldName}>
      {hasTitle && (
        <h2 className="error-label">
          {t(`${fieldName}.title`)}
          {required && <span className="required">*</span>}
        </h2>
      )}
      {hasExplanation && <p>{t(`${fieldName}.explanation`)}</p>}
      {hasLabel && (
        <span className="error-label">
          {t(`${fieldName}.label`)}
          {required && <span className="required">*</span>}
        </span>
      )}
    </Form.Label>
  );
};

export default NumberInputLabel;
